const userManualLink = {
    researcher: `${process.env.PUBLIC_URL}/document/UM_Researcher.pdf`,
    officer: `${process.env.PUBLIC_URL}/document/UM_Officer.pdf`,
    executive: `${process.env.PUBLIC_URL}/document/UM_Executive.pdf`,
    committee: `${process.env.PUBLIC_URL}/document/UM_Director.pdf`,
}
export default userManualLink
